export enum Columns {
  Actions = 'actions',
  Customers = 'customers',
  PurchasedOn = 'PurchasedOn',
  Subscription = 'subscription',
  Usage = 'usage',
  ValidUntil = 'validUntil',
}
